export default "__VITE_ASSET__CeSaiMBU__"